import React, { Component } from "react";
import { View, Image, TouchableOpacity, ScrollView, KeyboardAvoidingView, Platform } from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, customerLocationStyles, profileStyles, componentStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import Button from "../components/Button";
import { blueDarkColor, blueLightColor } from "../theme/colors";
import Waiting from "../components/Waiting";
import { createFavoritPersonRequest, editFavoritPersonRequest } from "../utils/api";
import { showMessage, getError } from "../utils/utils";
import TextInput from "../components/TextInput/TextInput";
import { wp } from "../utils/responsive";

export default class NewFavoritPersonScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            name: '',
            id: 0,
            national_code: '',
            relation: '',
            mobile: '',
            phone: '',
            gender: 0,
            waiting: false
        }
        this.inputs = {};
    }
    focusTheField = (prev, next) => {
        this.inputs[prev].blur()

        this.inputs[next].focus();
    }
    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>{this.state.id == 0 ? 'افزودن اشخاص منتخب' : 'ویرایش'}</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <ScrollView enableOnAndroid={true} keyboardShouldPersistTaps='handled'>
                <LinearGradient colors={[blueDarkColor, blueLightColor]} style={profileStyles.wraper}>
                    <View style={{ alignItems: 'center' }}>
                        <TextInput
                            label='نام و نام خانوادگی'
                            labelColor={'white'}
                            textColor={'white'}
                            ref={input => { this.inputs['fname'] = input }}
                            returnKeyType={'next'}
                            onSubmitEditing={() => { this.focusTheField('fname', 'relation') }}
                            wrapperStyle={{ width: wp(90) }}
                            onChangeText={(text) => {
                                this.setState({
                                    name: text
                                })
                            }}
                            value={this.state.name} />
                        <TextInput
                            label='نسبت'
                            labelColor={'white'}
                            textColor={'white'}
                            ref={input => { this.inputs['relation'] = input }}
                            returnKeyType={'next'}
                            onSubmitEditing={() => { this.focusTheField('relation', 'codemeli') }}
                            wrapperStyle={{ width: wp(90) }}
                            onChangeText={(text) => {
                                this.setState({
                                    relation: text
                                })
                            }}
                            value={this.state.relation} />

                        <View style={[appStyles.rowBetween, { width: wp(80), paddingLeft: 0, paddingRight: 0, paddingTop: 10 }]}>
                            <View style={componentStyles.switchButtonWraper}>

                                <TouchableOpacity style={this.state.gender == 1 ? componentStyles.activeButton : componentStyles.deactiveButton} onPress={() => {
                                    this.setState({
                                        gender: 1
                                    })
                                }}>
                                    <TextView style={this.state.gender == 1 ? componentStyles.activeTextButton : componentStyles.deactiveTextButton}>زن</TextView>
                                </TouchableOpacity>
                                <TouchableOpacity style={this.state.gender == 0 ? componentStyles.activeButton : componentStyles.deactiveButton} onPress={() => {
                                    this.setState({
                                        gender: 0,
                                    })
                                }}>
                                    <TextView style={this.state.gender == 0 ? componentStyles.activeTextButton : componentStyles.deactiveTextButton}>مرد</TextView>
                                </TouchableOpacity>
                            </View>
                            <TextView style={{ color: 'white' }}>انتخاب جنسیت مددجو</TextView>
                        </View>
                        <TextInput
                            label='کد ملی'
                            inputType='numeric'
                            labelColor={'white'}
                            textColor={'white'}
                            ref={input => { this.inputs['codemeli'] = input }}
                            returnKeyType={'next'}
                            onSubmitEditing={() => { this.focusTheField('codemeli', 'mobile') }}
                            wrapperStyle={{ width: wp(90) }}
                            onChangeText={(text) => {
                                this.setState({
                                    national_code: text
                                })
                            }}
                            value={this.state.national_code} />
                        <TextInput
                            label='شماره موبایل'
                            inputType='numeric'
                            labelColor={'white'}
                            textColor={'white'}
                            ref={input => { this.inputs['mobile'] = input }}
                            returnKeyType={'next'}
                            onSubmitEditing={() => { this.focusTheField('mobile', 'phone') }}
                            wrapperStyle={{ width: wp(90) }}
                            onChangeText={(text) => {
                                this.setState({
                                    mobile: text
                                })
                            }}
                            value={this.state.mobile} />
                        <TextInput
                            label='شماره ثابت'
                            inputType='numeric'
                            labelColor={'white'}
                            textColor={'white'}
                            ref={input => { this.inputs['phone'] = input }}
                            returnKeyType={'done'}
                            onSubmitEditing={() => {
                                this.send()
                            }}
                            wrapperStyle={{ width: wp(90) }}
                            onChangeText={(text) => {
                                this.setState({
                                    phone: text
                                })
                            }}
                            value={this.state.phone} />

                    </View>
                    <View style={[appStyles.bottomView, appStyles.center]}>

                        <Button
                            style={customerLocationStyles.button}
                            text={this.state.id === 0 ? 'ثبت مددجوی منتخب' : 'ویرایش مددجوی منتخب'}
                            textStyle={customerLocationStyles.buttonText}
                            onPress={() => {
                                this.send()
                            }}
                        />
                    </View>
                </LinearGradient>
            </ScrollView>
            <Waiting waiting={this.state.waiting} />
        </View>)
    }
    send() {
        if (this.state.name.length > 0 &&
            this.state.relation.length > 0 &&
            this.state.mobile.length > 0) {
            this.setState({
                waiting: true
            })
            if (this.state.id == 0) {
                createFavoritPersonRequest(this.state.relation, this.state.name, this.state.gender == 0 ? 'male' : 'female', this.state.mobile, this.state.phone, this.state.national_code, (isConnect, response) => {
                    this.setState({
                        waiting: false
                    })
                    if (isConnect && response.isSuccess) {
                        this.props.route.params.refresh();
                        this.props.navigation.goBack()
                    } else {
                        showMessage('', getError(response))
                    }
                })
            } else {
                editFavoritPersonRequest(this.state.id, this.state.relation, this.state.name, this.state.gender == 0 ? 'male' : 'female', this.state.mobile, this.state.phone, this.state.national_code, (isConnect, response) => {
                    this.setState({
                        waiting: false
                    })
                    if (isConnect && response.isSuccess) {
                        this.props.route.params.refresh();
                        this.props.navigation.goBack()
                    } else {
                        showMessage('', getError(response))
                    }
                })
            }


        }
    }
    componentWillMount() {
        if (this.props.route.params.data != null) {
            var data = this.props.route.params.data;
            this.setState({
                name: data.flname,
                phone: data.phone,
                mobile: data.cellphone,
                national_code: data.codemeli,
                gender: data.sex.includes('female') ? 1 : 0,
                relation: data.typerelation,
                id: data.id
            })
        }
    }
}
